/* ===================================================================
   LINNEA — product-template.js
   =================================================================== */

// ── ANNOUNCE BAR ROTATION ──
(function () {
  const msgs = [
    'Free UK delivery on orders over £50',
    'Ships in 1 to 2 days, fully tracked',
    'Easy 30-day returns. Nothing extra to pay on arrival'
  ];
  let idx = 0;
  const ann = document.getElementById('ann');
  if (!ann) return;
  setInterval(() => {
    ann.style.opacity = '0';
    setTimeout(() => {
      ann.textContent = msgs[++idx % msgs.length];
      ann.style.opacity = '1';
    }, 280);
  }, 4000);
})();

// ── TABS ──
function setTab(btn) {
  const bar = btn.closest('.tab-bar');
  bar.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
  btn.classList.add('active');
  const section = btn.closest('.tabs-section');
  section.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
  document.getElementById(btn.dataset.tab).classList.add('active');
}

// ── GALLERY: THUMBNAIL SWAP + SWIPE ──
(function () {
  const mainImg = document.getElementById('main-img');
  const mainWrap = document.querySelector('.gallery-main');
  const thumbs = Array.from(document.querySelectorAll('.thumb'));
  if (!mainImg || thumbs.length === 0) return;

  function activateThumb(thumb) {
    thumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
    if (thumb.dataset.src) mainImg.src = thumb.dataset.src;
    if (thumb.dataset.alt) mainImg.alt = thumb.dataset.alt;
  }

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => activateThumb(thumb));
  });

  if (mainWrap && thumbs.length > 1) {
    function goToOffset(offset) {
      const currentIndex = thumbs.findIndex(t => t.classList.contains('active'));
      const nextIndex = (currentIndex + offset + thumbs.length) % thumbs.length;
      activateThumb(thumbs[nextIndex]);
    }

    let startX = 0;
    let startY = 0;
    let tracking = false;

    mainWrap.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    mainWrap.addEventListener('touchmove', (e) => {
      if (!tracking || e.touches.length !== 1) return;
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy)) e.preventDefault();
    }, { passive: false });

    mainWrap.addEventListener('touchend', (e) => {
      if (!tracking) return;
      tracking = false;
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        goToOffset(dx < 0 ? 1 : -1);
      }
    });
  }
})();

// ── VARIANT PICKER (generic — works for any option set, any number of options) ──
var lneaVariants = [];
var lneaSelectedOptions = [];

(function () {
  const jsonEl = document.getElementById('product-variants-json');
  if (!jsonEl) return;
  try {
    lneaVariants = JSON.parse(jsonEl.textContent);
  } catch (e) {
    lneaVariants = [];
    return;
  }

  // Seed selected options from whatever is marked active/selected in the initial render,
  // so the state machine starts in sync with the server-rendered current variant.
  const groups = {};
  document.querySelectorAll('[data-option-index]').forEach(el => {
    const idx = parseInt(el.dataset.optionIndex, 10);
    if (isNaN(idx)) return;
    if (el.tagName === 'SELECT') {
      groups[idx] = el.value;
    } else if (el.dataset.value !== undefined && el.classList.contains('active')) {
      groups[idx] = el.dataset.value;
    }
  });
  Object.keys(groups).forEach(k => { lneaSelectedOptions[parseInt(k, 10)] = groups[k]; });

  lneaRefreshVariantUI();
})();

function lneaFindVariant(options) {
  return lneaVariants.find(v => v.options.every((val, i) => val === options[i]));
}

function lneaRefreshVariantUI() {
  const variant = lneaFindVariant(lneaSelectedOptions);

  document.querySelectorAll('[data-option-index]').forEach(group => {
    const idx = parseInt(group.dataset.optionIndex, 10);

    if (group.tagName === 'SELECT') {
      Array.from(group.options).forEach(opt => {
        const testOptions = lneaSelectedOptions.slice();
        testOptions[idx] = opt.value;
        const candidate = lneaFindVariant(testOptions);
        const reachable = !!candidate && candidate.available;
        opt.disabled = !reachable && opt.value !== lneaSelectedOptions[idx];
      });
      return;
    }

    group.querySelectorAll('[data-value]').forEach(btn => {
      const val = btn.dataset.value;
      const isSelected = val === lneaSelectedOptions[idx];
      const testOptions = lneaSelectedOptions.slice();
      testOptions[idx] = val;
      const candidate = lneaFindVariant(testOptions);
      const reachable = !!candidate && candidate.available;

      btn.classList.toggle('active', isSelected);
      btn.classList.toggle('is-unavailable', !reachable);
      btn.disabled = !reachable && !isSelected;
    });
  });

  lneaSelectedOptions.forEach((val, idx) => {
    const labelEl = document.getElementById('option-label-' + idx);
    if (labelEl && val !== undefined) labelEl.textContent = '· ' + val;
  });

  const atcBtn = document.querySelector('.atc-btn');
  const priceEl = document.getElementById('price');
  const stickyPriceEl = document.getElementById('sticky-price');
  const variantInput = document.getElementById('variant-id');

  if (variant) {
    if (priceEl) priceEl.textContent = variant.price;
    if (stickyPriceEl) stickyPriceEl.textContent = variant.price;
    if (variantInput) variantInput.value = variant.id;
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to cart' : 'Out of stock';
    }
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  } else if (atcBtn) {
    atcBtn.disabled = true;
    atcBtn.textContent = 'Unavailable';
  }
}

function setOptionValue(el) {
  const idx = parseInt(el.dataset.optionIndex, 10);
  lneaSelectedOptions[idx] = el.dataset.value;
  lneaRefreshVariantUI();
}

function setOptionValueFromSelect(sel) {
  const idx = parseInt(sel.dataset.optionIndex, 10);
  lneaSelectedOptions[idx] = sel.value;
  lneaRefreshVariantUI();
}

// ── STICKY ATC: IntersectionObserver ──
(function () {
  const stickyAtc = document.getElementById('sticky-atc');
  const atcRow = document.querySelector('.atc-row');
  if (!stickyAtc || !atcRow) return;
  const obs = new IntersectionObserver(([entry]) => {
    stickyAtc.classList.toggle('hidden', entry.isIntersecting);
  }, { threshold: 0.1 });
  obs.observe(atcRow);
})();

// ── CART: AJAX add + open Horizon drawer ──
async function lneaAddToCart(btn) {
  const form = document.getElementById('product-form');
  if (!form) return;

  btn.disabled = true;
  const original = btn.textContent;
  btn.textContent = 'Adding…';

  try {
    const formData = new FormData(form);

    // Ask Shopify to re-render the cart drawer section and return it in the response
    const cartItemsEl = document.querySelector('cart-items-component[data-section-id]');
    const sectionId = cartItemsEl?.dataset.sectionId || 'cart-drawer-section';
    formData.append('sections', sectionId);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });
    if (!res.ok) throw new Error('add failed');

    const data = await res.json();

    // Patch the cart drawer DOM with the freshly rendered section
    if (data.sections?.[sectionId]) {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(data.sections[sectionId], 'text/html');
      const newInner = newDoc.querySelector('.cart-drawer__inner');
      const curInner = document.querySelector('.cart-drawer__inner');
      if (newInner && curInner) {
        // Copy className so cart-drawer--empty is removed when cart has items
        curInner.className = newInner.className;
        curInner.innerHTML = newInner.innerHTML;
      }
    }

    // Open the drawer
    const themeDrawer = document.querySelector('theme-drawer#cart-drawer');
    if (themeDrawer && typeof themeDrawer.open === 'function') {
      themeDrawer.open();
    }

    btn.textContent = 'Added!';
    setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1400);
  } catch {
    btn.textContent = original;
    btn.disabled = false;
    window.location.href = '/cart';
  }
}

// Wire main ATC button
(function () {
  const atcBtn = document.querySelector('.atc-btn');
  if (!atcBtn) return;
  atcBtn.addEventListener('click', (e) => {
    e.preventDefault();
    lneaAddToCart(atcBtn);
  });
})();

// Wire sticky ATC button
(function () {
  const stickyBtn = document.querySelector('.sticky-atc-btn');
  if (!stickyBtn) return;
  stickyBtn.addEventListener('click', () => lneaAddToCart(stickyBtn));
})();
